(() => {
  const currency = window.Shopify?.currency?.active || 'EUR';
  const root = window.Shopify?.routes?.root || '/';

  const money = (cents) => new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
  }).format(Math.max(0, cents) / 100);

  const renderShipping = (totalPrice) => {
    document.querySelectorAll('[data-mmg-shipping]').forEach((box) => {
      const threshold = Number(box.dataset.mmgShippingThreshold || 4000);
      const total = Number(totalPrice || 0);
      const remaining = Math.max(0, threshold - total);
      const progress = Math.min(100, Math.max(0, (total / threshold) * 100));
      const complete = remaining <= 0;
      const message = box.querySelector('[data-mmg-shipping-message]');
      const thresholdLabel = box.querySelector('[data-mmg-shipping-threshold-label]');
      const bar = box.querySelector('[data-mmg-shipping-progress]');
      const track = box.querySelector('[role="progressbar"]');

      box.classList.toggle('mmg-cart-shipping--complete', complete);
      if (message) message.textContent = complete
        ? 'Gratis verzending is voor jou geregeld ✓'
        : `Nog ${money(remaining)} tot gratis verzending`;
      if (thresholdLabel) thresholdLabel.textContent = money(threshold);
      if (bar) bar.style.width = `${progress}%`;
      if (track) track.setAttribute('aria-valuenow', String(Math.round(progress)));
    });
  };

  const syncShippingFromCart = () => {
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((cart) => renderShipping(cart.total_price))
      .catch(() => {});
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncShippingFromCart, { once: true });
  } else {
    syncShippingFromCart();
  }

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.cartData?.total_price != null) renderShipping(event.cartData.total_price);
      else syncShippingFromCart();
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mmg-discount-button]');
    if (!button) return;

    const box = button.closest('[data-mmg-discount-box]');
    const input = box?.querySelector('[data-mmg-discount-input]');
    const message = box?.querySelector('[data-mmg-discount-message]');
    const code = input?.value?.trim();

    if (!code) {
      if (message) message.textContent = 'Vul eerst een kortingscode in.';
      input?.focus();
      return;
    }

    if (message) message.textContent = 'Je code wordt gecontroleerd…';
    window.location.assign(`${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(root + 'cart')}`);
  });
})();
